import { useCallback, useState } from 'react';

import { useActivityBuilderContext } from 'approot/activity-builder/activity-builder.context';
import { useBatchComponentUpdateContext } from '../shared/batch-component-update.context';
import { FileDropperContextProvider } from 'lib/form/file-dropper/file-dropper.context';
import { useSimpleModalState } from 'approot/shared/modal/modal.hooks';
import { ComponentDimensions } from '../shared/component-height/component-dimensions';
import { EditProps } from './gif.constants';
import GifEditModal from './gif-edit-modal';
import GifEditUpload from './gif-edit-upload';
import GifView from './gif-view';

const GifEdit = (props: EditProps) => {
  const { sectionId, id, properties } = props;

  const [newFileProps, setNewFileProps] = useState<{
    key: string;
    fileName: string;
    file: File;
  }>();

  const { isVisible, openModal, closeModal } = useSimpleModalState();
  const { activeComponent } = useActivityBuilderContext();

  const { updateComponentProperties } = useBatchComponentUpdateContext();

  const handleUpdateHeight = useCallback(
    (width: number, height: number) => {
      const dimensionData = {
        ...properties.dimensionData,
        width,
        height: Math.floor(height),
      };
      updateComponentProperties({
        input: {
          sectionId,
          componentId: id,
          componentData: {
            properties: {
              dimensionData,
            },
          },
        },
        properties: {
          ...properties,
          dimensionData,
        },
        typename: 'ActivitiesGifComponent',
      });
    },
    [id, sectionId, properties, updateComponentProperties]
  );

  return (
    <ComponentDimensions
      id={id}
      showHandle={activeComponent?.id === id}
      defaultValue={properties.dimensionData}
      onResizeEnd={handleUpdateHeight}
    >
      {isVisible && (
        <GifEditModal
          {...props}
          fileToUpload={newFileProps}
          onClose={closeModal}
        />
      )}
      {properties.image?.key ? (
        <GifView {...props} />
      ) : (
        <FileDropperContextProvider>
          <GifEditUpload
            id={id}
            onShowModal={newFileProps => {
              setNewFileProps(newFileProps);
              openModal();
            }}
          />
        </FileDropperContextProvider>
      )}
    </ComponentDimensions>
  );
};

export default GifEdit;
